import React, { useContext, useEffect, useState } from "react";
import TabContainer from "../../components/TabContainer/TabContainer";
import CustomTab from "../../components/TabContainer/CustomTab";
import CustomBreadCrumb from "../../components/CustomBreadCrumb";
import ChartComponent from "./ChartCompoment";
import { getAnalyticsData, getStudyCounts } from "../../service/AnalyticsService";
import { ReactQueryDevtools } from "react-query/devtools";
import { QueryClient, QueryClientProvider } from "react-query";
import {
  Calendar,
  DatePicker,
  PrimaryButton,
  defaultCalendarStrings,
  defaultDatePickerStrings,
} from "@fluentui/react";
import "./Analytics.css";
import Moment from "moment";
import { filter } from "underscore";
import { t } from "i18next";
import { ad } from "@kitware/vtk.js/Common/Core/Math/index";
import AlertSuccessModal from "../../components/AlertSuccessModal/AlertSuccessModal";
import userContext from "../../context/users/UserContext";
import { USERTYPES } from "../../constants/Constants";
import ThemeContext from "../../context/theme/ThemeContext";
import OnlineRadiologist from "./OnlineRadiologist";


const queryClient = new QueryClient();


const primaryButtonHoverStyles = {
  rootHovered: {
    color: "white",
  },
};

const Analytics = () => {
  const { getThemeColor } = useContext(ThemeContext);

  const [annotationList, setAnnotationList] = useState([]);
  const [modalityList, setModalityList] = useState([]);
  const [providerList, setProviderList] = useState([]);
  const [userList, setUserList] = useState([]);
  const [clientList, setClientList] = useState([]);
  const [dateBy, setDateBy] = useState(1);
  const [studyCount, setStudyCount] = useState({});
  const [showStudyCount, setShowStudyCount] = useState(false);
  const [allModalitySelected, setAllModalitySelected] = useState([]);
  const [allRadiologistSelected, setAllRadiologistSelected] = useState([]);
  const [returnedReasonList, setReturnedReasonList] = useState([]);
  const [raiseAlertReasonList, setRaiseAlertReasonList] = useState([]);
  const [allReturnedReasonSelected, setAllReturnedReasonSelected] = useState([]);
  const [allRaiseAlertReasonSelected, setAllRaiseAlertReasonSelected] = useState([]);
  const [isOnlineRadiologistSelected,setIsOnlineRadiologistSelected]=useState(false);
  const [dateList, setDateList] = useState([{ key: 1, text: "Today" },{ key: 2, text: "Last 2 Days" },{ key: 3, text: "Last 3 Days" },{ key: 4, text: "Last 7 Days" },{ key: 5, text: "1 Month" },{ key: 6, text: "Custom" }]);
  const [alertSuccessModal, setAlertSuccessModal] = useState({
    show: false,
    isError: false,
    isWarning: false,
    isSuccess: false,
    heading: "",
    description: "",
  });
  const { roles, authenticated, firmId, loadByUsername, userId } =
    useContext(userContext);
  const today = new Date();
  let toDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);
  let fromDate = new Date(today.getFullYear(), today.getMonth() - 5, 1);
  const [filterObj, setFilterObj] = useState({
    dateTo: toDate,
    dateFrom: fromDate,
  });

  const [adminChartEnabled, setAdminChartEnabled] = useState(null);
  const last2DaysDate = new Date(today.getFullYear(), today.getMonth(), today.getDate()-1);
  const todayDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  const formatDate = (date) => {
    var currentDate = Moment(date).local().format("DD-MMM-YYYY");
    return date == "" ? "" : currentDate;
  };
  const [objForEditedStudies, setObjForEditedStudies] = useState({
      dateFrom: formatDate(last2DaysDate),
      dateTo: formatDate(todayDate),
      selectedDate: 2,
      dateByInComponent: 1,
      totalCounts: 0
  })

  const breadCrumbItems = [
    {
      text: "Analytics",
      key: "analytics",
    },
  ];

  const tabDetails = [
    {
      selectedKey: "1",
      tabName: t("analytics.findings"),
      tabKeyContain: (
        <CustomTab
          key="1"
          orderNumber="1"
          tabName={t("analytics.findings")}
          subtitle="Visualize distribution patterns in findings"
          iconName={""}
          iconColor={"white"}
        />
      ),
      tabValueContain: (
        <ChartComponent
          chartType="pathology_count"
          isPie={true}
          isBar={false}
          tabNo={1}
          pathologyList={annotationList}
          filterObj={filterObj}
          dateBy={dateBy}
          setAlertSuccessModal={setAlertSuccessModal}
          alertSuccessModal={alertSuccessModal}
          objForEditedStudies={null}
          setObjForEditedStudies={null}
          setIsOnlineRadiologistSelected={setIsOnlineRadiologistSelected}
        />
      ),
    },
    {
      selectedKey: "2",
      tabName: t("analytics.studies"),
      tabKeyContain: (
        <CustomTab
          key="2"
          orderNumber="2"
          tabName={t("analytics.studies")}
          subtitle="Explore and engage with platform studies"
          iconName={""}
          iconColor={"white"}
        />
      ),
      tabValueContain: (
        <ChartComponent
          chartType="upload_count"
          isBar={true}
          isPie={false}
          tabNo={2}
          modalityList={modalityList}
          clientList={clientList}
          filterObj={filterObj}
          dateBy={dateBy}
          setAlertSuccessModal={setAlertSuccessModal}
          alertSuccessModal={alertSuccessModal}
          objForEditedStudies={null}
          setObjForEditedStudies={null}
          setIsOnlineRadiologistSelected={setIsOnlineRadiologistSelected}
        />
      ),
    },
    {
      selectedKey: "3",
      tabName: t("analytics.gender"),
      tabKeyContain: (
        <CustomTab
          key="3"
          orderNumber="3"
          tabName={t("analytics.gender")}
          subtitle="Analyze distribution based on gender"
          iconName={""}
          iconColor={"white"}
        />
      ),
      tabValueContain: (
        <ChartComponent
          chartType="gender_count"
          isBar={true}
          isPie={false}
          tabNo={3}
          pathologyList={annotationList}
          filterObj={filterObj}
          dateBy={dateBy}
          setAlertSuccessModal={setAlertSuccessModal}
          alertSuccessModal={alertSuccessModal}
          objForEditedStudies={null}
          setObjForEditedStudies={null}
          setIsOnlineRadiologistSelected={setIsOnlineRadiologistSelected}
        />
      ),
    },
    {
      selectedKey: "4",
      tabName: t("analytics.reporting"),
      tabKeyContain: (
        <CustomTab
          key="4"
          orderNumber="4"
          subtitle="Monitor the status of your reports"
          tabName={t("analytics.reporting")}
          iconName={""}
          iconColor={"white"}
        />
      ),
      tabValueContain: (
        <ChartComponent
          chartType="report_count"
          isBar={true}
          isPie={false}
          tabNo={4}
          clientList={clientList}
          filterObj={filterObj}
          dateBy={dateBy}
          setAlertSuccessModal={setAlertSuccessModal}
          alertSuccessModal={alertSuccessModal}
          objForEditedStudies={null}
          setObjForEditedStudies={null}
          setIsOnlineRadiologistSelected={setIsOnlineRadiologistSelected}
        />
      ),
    },
    {
      selectedKey: "5",
      tabName: t("analytics.tat"),
      tabKeyContain: (
        <CustomTab
          key="5"
          orderNumber="5"
          subtitle="Track and improve report turnaround time"
          tabName={t("analytics.tat")}
          iconName={""}
          iconColor={"white"}
        />
      ),
      tabValueContain: (
        <ChartComponent
          chartType="user_count"
          isBar={true}
          isPie={false}
          tabNo={5}
          modalityList={modalityList}
          providerList={providerList}
          userList={userList}
          clientList={clientList}
          filterObj={filterObj}
          dateBy={dateBy}
          setAlertSuccessModal={setAlertSuccessModal}
          alertSuccessModal={alertSuccessModal}
          objForEditedStudies={null}
          setObjForEditedStudies={null}
          setIsOnlineRadiologistSelected={setIsOnlineRadiologistSelected}
        />
      ),
    },
  ];
  if((roles[0]==USERTYPES.FIRMADMIN ||roles[0]==USERTYPES.SUPERVISOR) && !adminChartEnabled && process.env.REACT_APP_VDC_PLATFORM==="false")
  {
    tabDetails.push( {
      selectedKey: "6",
      tabName: t("analytics.online-radiologist"),
      tabKeyContain: (
        <CustomTab
          key="6"
          orderNumber="6"
          subtitle="Online Radiologist on platform"
          tabName={t("analytics.online-radiologist")}
          iconName={""}
          iconColor={"white"}
        />
      ),
      tabValueContain: (
        <OnlineRadiologist setIsOnlineRadiologistSelected={setIsOnlineRadiologistSelected}/>
      ),
    })}
  
  if(roles[0] === USERTYPES.FIRMADMIN && adminChartEnabled ){
    tabDetails.push({
      selectedKey: "6",
      tabName: t("analytics.edited-studies"),
      tabKeyContain: (
        <CustomTab
          key="6"
          orderNumber="6"
          tabName={t("analytics.edited-studies")}
          iconName={""}
          iconColor={"white"}
          subtitle="Explore edited studies on platform"
        />
      ),
      tabValueContain: (
        <ChartComponent
          chartType="edit_reports_count"
          isBar={true}
          isPie={false}
          tabNo={6}
          // clientList={clientList}
          modalityList={modalityList}
          userList={userList}
          filterObj={filterObj}
          dateBy={dateBy}
          dateList={dateList}
          allModalitySelected={allModalitySelected}
          allRadiologistSelected={allRadiologistSelected}
          objForEditedStudies={objForEditedStudies}
          setObjForEditedStudies={setObjForEditedStudies}
          setAlertSuccessModal={setAlertSuccessModal}
          alertSuccessModal={alertSuccessModal}
          setIsOnlineRadiologistSelected={setIsOnlineRadiologistSelected}
        />
      ),
    }, 
    {
      selectedKey: "7",
      tabName: t("analytics.returned-studies"),
      tabKeyContain: (
        <CustomTab
          key="7"
          orderNumber="7"
          tabName={t("analytics.returned-studies")}
          iconName={""}
          iconColor={"white"}
          subtitle="Explore returned studies on platform"
        />
      ),
      tabValueContain: (
        <ChartComponent
          chartType="returned_studies_count"
          isBar={true}
          isPie={false}
          tabNo={7}
          // clientList={clientList}
          modalityList={modalityList}
          userList={userList}
          returnedReasonList={returnedReasonList}
          filterObj={filterObj}
          dateBy={dateBy}
          dateList={dateList}
          allModalitySelected={allModalitySelected}
          allRadiologistSelected={allRadiologistSelected}
          objForEditedStudies={objForEditedStudies}
          setObjForEditedStudies={setObjForEditedStudies}
          allReturnedReasonSelected={allReturnedReasonSelected}
          setAlertSuccessModal={setAlertSuccessModal}
          alertSuccessModal={alertSuccessModal}
          setIsOnlineRadiologistSelected={setIsOnlineRadiologistSelected}
        />
      ),
    },
    {
      selectedKey: "8",
      tabName: t("analytics.raised-alert-studies"),
      tabKeyContain: (
        <CustomTab
          key="8"
          orderNumber="8"
          tabName={t("analytics.raised-alert-studies")}
          iconName={""}
          iconColor={"white"}
          subtitle="Explore raised alert studies on platform"
        />
      ),
      tabValueContain: (
        <ChartComponent
          chartType="raised_alert_count"
          isBar={true}
          isPie={false}
          tabNo={8}
          // clientList={clientList}
          modalityList={modalityList}
          userList={userList}
          raiseAlertReasonList={raiseAlertReasonList}
          filterObj={filterObj}
          dateBy={dateBy}
          dateList={dateList}
          allModalitySelected={allModalitySelected}
          allRadiologistSelected={allRadiologistSelected}
          allRaiseAlertReasonSelected={allRaiseAlertReasonSelected}
          objForEditedStudies={objForEditedStudies}
          setObjForEditedStudies={setObjForEditedStudies}
          setAlertSuccessModal={setAlertSuccessModal}
          alertSuccessModal={alertSuccessModal}
          setIsOnlineRadiologistSelected={setIsOnlineRadiologistSelected}

        />
      ),
    })

  }
  if((roles[0]==USERTYPES.FIRMADMIN ||roles[0]==USERTYPES.SUPERVISOR) && adminChartEnabled && process.env.REACT_APP_VDC_PLATFORM==="false")
    {
      tabDetails.push( {
        selectedKey: "9",
        tabName: t("analytics.online-radiologist"),
        tabKeyContain: (
          <CustomTab
            key="9"
            orderNumber="9"
            subtitle="Online Radiologist on platform"
            tabName={t("analytics.online-radiologist")}
            iconName={""}
            iconColor={"white"}
          />
        ),
        tabValueContain: (
          <OnlineRadiologist setIsOnlineRadiologistSelected={setIsOnlineRadiologistSelected}/>
        ),
      })
    }

  //Setting this to false by default temporarily due to slow analytics query
  const showAnalyticsTotalCount = false;
  
  // const showAnalyticsTotalCount = process.env.REACT_APP_VDC_PLATFORM === "true"? (roles[0] === USERTYPES.FIRMADMIN ||
  //   roles[0] === USERTYPES.SUPERVISOR ||
  //   roles[0] === USERTYPES.ADMIN ||
  //   roles[0] === USERTYPES.RADIOLOGIST) : false;
    

  const fetchAnalyitcsStudyCount = async() => {
    if (showAnalyticsTotalCount) {
      const studyCountResponse = await getStudyCounts();
      setStudyCount(studyCountResponse?.data.data);
    }
  }


  const fetchAnalyticsData = async () => {

    const response = await getAnalyticsData();
    let tempAnnotationList = response.data.data.annotationList;
    let tempModalityList = response.data.data.modalityList;
    let tempClientList = response.data.data.hospitalchklist;
    let tempProviderList = response.data.data.providerFirmList;
    let tempUserList = response.data.data.userList;
    let tempReturnedReasonList = response.data.data.returnedReasonsList;
    let tempRaiseAlertReasonList = response.data.data.raiseAlertReasonsList;
    let chartEnabled = response.data.data.adminChartEnabled;

    //console.log('admin charts ........ enabled', chartEnabled);
    setAdminChartEnabled(chartEnabled);
    setAnnotationList(
      tempAnnotationList.map((a) => {
        return { key: a.name, text: a.name };
      })
    );
    setModalityList(
      tempModalityList.map((m) => {
        return { key: m.id + "", text: m.name };
      })
    );
    setAllModalitySelected(tempModalityList.map((m) => {
      return m.id+"" ;
    }));

    if (roles[0] === USERTYPES.FIRMADMIN || roles[0] === USERTYPES.SUPERVISOR) {      
      const otherClienList = tempClientList.map((c) => {
        if (c.id !== firmId) {
          return { key: c.id + "", text: c.name };
        }
      });
      setClientList([
        {
          key: -1 + "",
          text: "My Studies",
        },
        ...otherClienList,
      ]);
    } else if (roles[0] === USERTYPES.FIRMDOCTOR || roles[0] === USERTYPES.FIRMTECHNICIAN) {
      const otherClientList = tempClientList
        .filter(c => c.id !== firmId) 
        .map(c => ({ key: c.id.toString(), text: c.name }));
      const hasMyStudies = tempClientList.some(c => c.id === firmId);
      const newClientList = hasMyStudies
        ? [
            { key: "-1", text: "My Studies" },
            ...otherClientList
          ]
        : otherClientList;
      setClientList(newClientList);
    }else {
      setClientList(
        tempClientList.map((c) => {
          return { key: c.id + "", text: c.name };
        })
      );
    }

    setProviderList(
      tempProviderList.map((p) => {
        return { key: "F" + p.id, text: p.name };
      })
    );
    setUserList(
      tempUserList.map((u) => {
        return { key: "R" + u.id, text: u.firstName + " " + u.lastName };
      })
    );
    setAllReturnedReasonSelected(tempReturnedReasonList.map((r) => {
      return r+"" ;
    }));
    setAllRadiologistSelected(tempUserList.map((u) => {
      return "R" + u.id ;
    }));
    setReturnedReasonList(
      tempReturnedReasonList.map((r) => {
        console.log("r-----------------------", r);
        return {key: r+"" , text: r};
      })
    );
    setAllReturnedReasonSelected(tempReturnedReasonList.map((r) => {
      return r+"" ;
    }));
    setRaiseAlertReasonList(
      tempRaiseAlertReasonList.map((r) => {
        return {key: r.key+"" , text: r.value};
      })
    );
    setAllRaiseAlertReasonSelected(tempRaiseAlertReasonList.map((r) => {
      return r.key+"";
    }));
  };

  useEffect(() => {
    setProviderList([...providerList, ...userList]);
  }, [userList]);

  useEffect(() => {
    if(studyCount.totalStudies !== undefined || studyCount.length > 0)
      setShowStudyCount(true);
  }, [studyCount]);


  useEffect(() => {
    fetchAnalyticsData();
    fetchAnalyitcsStudyCount()
  }, []);

  const seletDateFrom = (date) => {
    // var formattedDate = formatDate(date);
    setFilterObj({ ...filterObj, dateFrom: date });
  };

  const seletDateTo = (date) => {
    // var formattedDate = formatDate(date);
    setFilterObj({ ...filterObj, dateTo: date });
  };

  const hideAlertSuccessModal = () => {
    setAlertSuccessModal(() => {
      const newItem = { ...alertSuccessModal };
      newItem.show = false;
      newItem.heading = "";
      newItem.description = "";
      return newItem;
    });
  };

  const getConsistentDateFormat = (date) => {
    if (Moment(date).isValid()) {
      return Moment(date).format("DD-MMM-YYYY");
    } else {
      return "No Date";
    }
  };

  return (
    <>
      {alertSuccessModal?.show && (
        <AlertSuccessModal
          isError={alertSuccessModal.isError}
          isWarning={alertSuccessModal.isWarning}
          isSuccess={alertSuccessModal.isSuccess}
          heading={alertSuccessModal.heading}
          description={alertSuccessModal.description}
          hideModal={hideAlertSuccessModal}
          isModalOpen={alertSuccessModal?.show}
        />
      )}
      <div className="main-container-body">
        <div className="breadCrumb">
          <CustomBreadCrumb items={breadCrumbItems} />
        </div>
        {/* <h2 style={{ padding: "15px" }}>{t("analytics.reporting-indicators")}</h2> */}
        {!isOnlineRadiologistSelected ? <div
          style={{
            width: "40%",
            display: "flex",
            marginLeft: "10px",
            height: "40px"
          }}
        >
          <div style={{ display: "flex",marginRight: "8px" }}>
            <PrimaryButton
              onClick={() => {
                setDateBy(1);
              }}
              text={t("analytics.assignment-date")}
              style={{
                fontSize: "12px",
                fontWeight: "400",
                padding: "0px 3px",
                whiteSpace: "nowrap",
                borderTopLeftRadius: "7px",
                borderBottomLeftRadius: "7px",
                zIndex: dateBy !== 1 ? "" : "100",
                background:dateBy === 1 ? "#0078d4" : getThemeColor("search-filter-bgm-nonactive"),
                color: dateBy === 1 ? "white" : getThemeColor("search-filter-nonactive"),
                outline: "white",
                borderTopRightRadius: dateBy == 1 ? "7px" : "",
                borderBottomRightRadius: dateBy == 1 ? "7px" : "",
                paddingRight: dateBy !== 1 ? "10px" : "",
                height: "32px"
              }}
              styles={primaryButtonHoverStyles}
            />
            <PrimaryButton
              onClick={() => {
                setDateBy(2);
              }}
              text={t("analytics.study-date")}
              style={{
                fontSize: "12px",
                fontWeight: "400",
                padding: "0px 3px",
                whiteSpace: "nowrap",
                marginLeft: "-12px",
                borderTopRightRadius: "7px",
                borderBottomRightRadius: "7px",
                paddingLeft: dateBy !== 2 ? "10px" : "",
                background:dateBy === 2 ? "#0078d4" : getThemeColor("search-filter-bgm-nonactive"),
                color: dateBy === 2 ? "white" : getThemeColor("search-filter-nonactive"),
                zIndex: dateBy !== 2 ? "" : "100",
                borderTopLeftRadius: dateBy == 2 ? "7px" : "",
                borderBottomLeftRadius: dateBy == 2 ? "7px" : "",
                height: "32px"
              }}
              styles={primaryButtonHoverStyles}
            />
          </div>
          <DatePicker
            className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
            style={{ width: "30%" }}
            name="dob"
            value={filterObj.dateFrom}
            onSelectDate={seletDateFrom}
            strings={defaultDatePickerStrings}
            placeholder={t("analytics.from")}
            maxDate={today}
            formatDate={getConsistentDateFormat}
          />
          <DatePicker
            className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
            style={{ width: "30%" }}
            name="dob"
            value={filterObj.dateTo}
            onSelectDate={seletDateTo}
            strings={defaultDatePickerStrings}
            placeholder={t("analytics.to")}
            maxDate={toDate}
            formatDate={getConsistentDateFormat}
          />
        </div>:<div style={{
            width: "40%",
            display: "flex",
            marginLeft: "10px",
            height: "40px"
          }}></div>}
        {showStudyCount ?
         (<div className="study-count-div"> 
            <div className="study-count-label">{t("analytics.total-studies")}<span className="study-count-saperator">|</span>{studyCount.totalStudies ? studyCount.totalStudies : 0}</div>
            <div className="study-count-label">{t("analytics.total-reported")}<span  className="study-count-saperator">|</span>{studyCount.totalReported  ? studyCount.totalReported : 0}</div>
            <div className="study-count-label">{t("analytics.unreported")}<span className="study-count-saperator">|</span>{studyCount.totalStudies && studyCount.totalReported ? studyCount.totalStudies - studyCount.totalReported : 0}</div>
            <div className="study-count-label">{t("analytics.total-assigned")}<span className="study-count-saperator">|</span>{studyCount.totalAssigned ? studyCount.totalAssigned : 0 }</div>
          { 
            (roles[0] === USERTYPES.FIRMADMIN ||
            roles[0] === USERTYPES.SUPERVISOR ||
            roles[0] === USERTYPES.ADMIN) &&
            (<div className="study-count-label">{t("analytics.unassigned")}<span className="study-count-saperator">|</span>{studyCount.totalStudies && studyCount.totalAssigned ? studyCount.totalStudies - studyCount.totalAssigned : 0}
            </div>)
          } 
          { 
            (roles[0] === USERTYPES.RADIOLOGIST) &&
            (<div className="study-count-label">{t("analytics.locked-by-you")}<span className="study-count-saperator">|</span>{studyCount.totalSelfLocked ? studyCount.totalSelfLocked : 0}
            </div>)
          } 
          {
            (roles[0] === USERTYPES.FIRMADMIN ||
              roles[0] === USERTYPES.SUPERVISOR ||
              roles[0] === USERTYPES.ADMIN) &&
            (<div className="study-count-label">{t("analytics.total-locked-unreported")}<span  className="study-count-saperator">|</span>{studyCount.totalLockedUnreported ? studyCount.totalLockedUnreported : 0 }
            </div>)
          }
        </div>)
        :( showAnalyticsTotalCount ? <div className="study-count-div" style={{fontStyle:"italic"}}>{t("analytics.loading")}</div> : null)
        }
        <QueryClientProvider client={queryClient}>
          {annotationList.length >= 0 &&
            modalityList.length >= 0 &&
            clientList.length >= 0 &&
            providerList.length >= 0 &&
            userList.length >= 0 &&
            Object.keys(filterObj).length > 0 &&
            dateBy !== undefined && (
                <TabContainer
                NoOfTabs={tabDetails.length}
                tabDetails={tabDetails}
                uniqueKey="analytics_"
                previousNextButtons={false}
                bottomButtons={false}
                onNextClick={() => console.log("Next clicked")}
                onEditClick={() => console.log("Next clicked")}
                mobileTabHeader={t("analytics.name")}
                customHeight="calc(100% - 100px)"
              />
            )}
          <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
      </div>
    </>
  );
};

export default Analytics;
